import { Button } from '@elysian/ui';
import { useAsync } from '../../data/useAsync';
import { useSession } from '../../state/session';
import { useToast } from '../../state/toast';

/** Copies text, with a fallback for browsers that only allow the clipboard over HTTPS. */
async function copy(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch { /* fall back below */ }
  const area = document.createElement('textarea');
  area.value = text;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.opacity = '0';
  document.body.appendChild(area);
  area.select();
  let ok = false;
  try { ok = document.execCommand('copy'); } catch { ok = false; }
  area.remove();
  return ok;
}

/** The books' address for bills (#22), with a Copy button. */
export function InboxAddress({ version = 0, label = 'Send bills to' }: { version?: number; label?: string }) {
  const { source } = useSession();
  const toast = useToast((t) => t.show);
  const data = useAsync(() => source.inboxAddress(), [source, version]);
  if (data.state === 'loading') return <div className="el-inbox-address"><div className="el-skeleton" style={{ width: 260, height: 18 }} /></div>;
  if (data.state === 'error') return null;
  const address = data.data.address;
  return (
    <div className="el-inbox-address" aria-label="The address for bills">
      <span className="el-hint">{label}</span>
      <div className="el-row" style={{ gap: 8, flexWrap: 'nowrap' }}>
        <a className="el-code el-inbox-email" href={`mailto:${address}`}>{address}</a>
        <Button size="sm" onClick={() => void copy(address).then((ok) => toast(ok ? `${address} copied` : 'Couldn’t copy; select the address and copy it'))}>
          Copy
        </Button>
      </div>
    </div>
  );
}
